import { useEffect } from 'react';

import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';

import { Button } from 'src/common/primitives/Button';
import { SearchTypeahead } from 'src/common/SearchTypeahead';

import {
  setDriverProfileSearchTerm,
  setSelectedDriverProfile,
  setShowDriverProfileModal,
} from './team.slice';

export function DriverProfileRouteActions() {
  const dispatch = useDispatch();
  const debounceSearch = debounce(handleSearch, 300);

  function handleSearch(term: string) {
    dispatch(setDriverProfileSearchTerm(term));
  }

  function handleAddDriverProfile() {
    dispatch(setSelectedDriverProfile(null));
    dispatch(setShowDriverProfileModal(true));
  }

  useEffect(() => {
    return () => {
      dispatch(setDriverProfileSearchTerm(''));
    };
  }, [dispatch]);

  return (
    <>
      <SearchTypeahead onChange={debounceSearch} placeholder="Search drivers" />
      <Button onClick={() => handleAddDriverProfile()} variant="primary">
        Add a Driver Profile
      </Button>
    </>
  );
}
